export default __webpack_public_path__ + "static/media/search-button.0588ea33.svg";